<ion-content *ngIf="news">
  <header>
    <ng-container *ngIf="width >= 480; else elseTemplate">
      <app-page-header class="no-mb">
        <ion-back-button pre defaultHref="panel/network/home" [text]="translate.instant('common.back')"> </ion-back-button>
        <small translate>news.subtitle</small>
        <h1>{{ getLocalized(news.title) }}</h1>
        <div aside class="header-side-info">
          <div *ngIf="fCategory" class="indicator loh center h-end">
            <div>
              <ion-icon name="calendar"></ion-icon>
              <span *ngIf="!news.startPostDate">
                {{ news.creationDate | date: 'dd/MM/yyyy' }}
                <span translate>news.details.at </span>
                {{ news.creationDate | date: 'HH:mm' }}
              </span>
              <span *ngIf="news.startPostDate">
                {{ news.startPostDate | date: 'dd/MM/yyyy' }}
                <span translate>news.details.at </span>
                {{ news.startPostDate | date: 'HH:mm' }}
              </span>
            </div>
          </div>
        </div>
      </app-page-header>
    </ng-container>
    <ng-template #elseTemplate>
      <app-page-header class="no-mb h-left">
        <ion-back-button
          pre
          (click)="router.navigateByUrl('/panel/network/home')"
          defaultHref="panel/network/home"
          [text]="translate.instant('common.back')"></ion-back-button>
        <small translate>news.subtitle</small>
        <h1>{{ getLocalized(news.title) }}</h1>
        <ion-row aside class="header-side-info">
          <div *ngIf="fCategory" class="indicator loh center h-end">
            <div>
              <ion-icon name="calendar"></ion-icon>
              <span *ngIf="!news.startPostDate">
                {{ news.creationDate | date: 'dd/MM/yyyy' }}
                <span translate>news.details.at </span>
                {{ news.creationDate | date: 'HH:mm' }}
              </span>
              <span *ngIf="news.startPostDate">
                {{ news.startPostDate | date: 'dd/MM/yyyy' }}
                <span translate>news.details.at </span>
                {{ news.startPostDate | date: 'HH:mm' }}
              </span>
            </div>
          </div>
        </ion-row>
      </app-page-header>
    </ng-template>
  </header>
  <main>
    <div #divHeigth class="loh wrap lov center">
      <div class="full-size card lov">
        <main
          [class]="
            (!getLocalized(news.image) && getLocalized(news.link)) || (news.isEmbed && cachedEmbedUrl)
              ? 'full-news-container'
              : 'simple-news-container'
          ">
          <div
            class="lov center"
            [class]="
              (!getLocalized(news.image) && getLocalized(news.link)) || (news.isEmbed && cachedEmbedUrl) ? 'full-height photo' : 'photo'
            "
            #photo>
            @if (news.isEmbed && cachedEmbedUrl) {
              <iframe
                class="full-width full-height iframe embed-canva"
                [src]="cachedEmbedUrl"
                allowfullscreen
                title="Embed da noticia"></iframe>
            } @else if (getLocalized(news.link)) {
              <iframe
                class="full-width full-height iframe"
                [src]="getLocalized(news.link) | safe"
                allowfullscreen
                title="Imagem de chamda de noticia">
              </iframe>
            } @else if (getLocalized(news.video) || news.internVideo) {
              <div>
                <div>
                  <video
                    #videoPlayer
                    class="large-photo video"
                    [src]="getLocalized(news.video) || news.internVideo"
                    [poster]="isIphone && news.internVideo.includes('video_caminhos') ? 'assets/images/ricardo.jpg' : ''"
                    controls
                    controlsList="nodownload">
                    Seu navegador não suporta o elemento de vídeo.
                  </video>
                </div>
              </div>
            } @else {
              <img
                class="img"
                [src]="getLocalized(news.image) ? getLocalized(news.image) : 'assets/images/grupo-jacto.svg'"
                alt="Imagem de chamda de noticia" />
            }
          </div>
          <div id="divContainer" class="text-news-container">
            <div *ngIf="loadInner" [innerHTML]="news.text[translate.currentLang]"></div>
            <div id="textNews" class="text-news"></div>
          </div>
        </main>
        <footer class="content-footer loh h-end">
          <ion-buttons class="loh h-sb center">
            <ion-button
              class="like-button"
              [ngClass]="liked == true ? 'button-liked' : 'button-not-liked'"
              (click)="like()"
              [disabled]="likeLoading">
              <ion-icon slot="icon-only" name="heart"></ion-icon>
            </ion-button>
            <label class="button-liked like-area-label">{{ news.Likes }}</label>
            <label class="button-liked like-area-text" translate>news.label.like</label>
            <div class="like-button comments-button loh center hover-comments">
              <ion-icon name="chatbubbles"></ion-icon>
            </div>
            <div class="hover-comments" (click)="gotoComment()">
              <label class="like-area-label comments-button hover-comments">{{ comments?.length }}</label>
              <label class="like-area-text comments-button hover-comments" translate>news.label.comment</label>
            </div>
          </ion-buttons>
        </footer>
      </div>
      <div *ngIf="relatedNews && !news.isEmbed" class="full-size">
        <app-news-card-list
          [relatedNews]="true"
          title="{{ 'news.title.related.details' | translate }}"
          [color]="'var(--ion-color-primary)'">
          <div data class="container-scrollable">
            <div *ngFor="let rel of relatedNews | slice: 0 : sliceRelated; let i = index" class="item-scrollable">
              <app-post-medium
                class="medium-post"
                (click)="changeParams(rel.id, true)"
                [news_data]="relatedNews[i]"
                [relatedNews]="true"></app-post-medium>
            </div>
            <div class="item-scrollable arrow-more" *ngIf="relatedNews.length >= batchSize && width > 500">
              <ion-button *ngIf="moreRelatedResults" fill="clear" (click)="getRelatedNews(true)" class="ion-no-padding" size="small">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </ion-button>
              <div *ngIf="!endRelatedResults">
                <ion-button fill="clear" class="ion-no-padding" *ngIf="!moreRelatedResults" expand="block">
                  <ion-spinner name="crescent"></ion-spinner>
                </ion-button>
              </div>
            </div>
            <div size="12" sizeMd="5" [hidden]="!isLoading" class="full-width" *ngFor="let news of fakeElementsLarg">
              <app-post-medium-loading class="medium-post"></app-post-medium-loading>
            </div>

            <ion-row class="lov center sticky-see-more-button">
              <div class="text-align-center" *ngIf="relatedNews.length >= batchSize && width <= 500">
                <ion-button *ngIf="moreRelatedResults" fill="clear" (click)="getRelatedNews(true)" class="ion-no-padding" size="small">
                  <ion-label color="primary" class="text-align-center" translate>common.more</ion-label>
                </ion-button>
                <div *ngIf="!endRelatedResults">
                  <ion-button fill="clear" class="ion-no-padding" *ngIf="!moreRelatedResults" expand="block">
                    <ion-spinner name="crescent"></ion-spinner>
                  </ion-button>
                </div>
              </div>
            </ion-row>
          </div>
        </app-news-card-list>
      </div>
    </div>

    <div class="full-size card p0 ms comment visible-area" (scroll)="onScroll($event)" #commentsDiv>
      <header class="wrap loh h-left comment-header" id="targetTopComments">
        <span class="comment-title bold m p" translate>news.label.comment</span>
      </header>

      <ion-grid class="tags ion-no-padding">
        <ion-row *ngFor="let c of comments" class="flex loh h-sb center">
          <div class="comment-main">
            <div>
              <ion-row class="comment-container">
                <h1>
                  {{ c.employeeName }}
                </h1>
                <div class="column-flex">
                  <span>
                    {{ c.commentDate | date: 'dd/MM/yyyy' }}
                    <span translate>news.details.at </span>
                    {{ c.commentDate | date: 'HH:mm' }}
                  </span>
                  <span translate *ngIf="c.edited" class="edited"> news.comments.label.edited</span>
                </div>
                <ion-buttons class="lov center comment-button-area">
                  <ion-button (click)="showPopover(c.id, c, $event)" class="like-button">
                    <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-row>
            </div>
            <ion-row id="text">{{ c?.text }}</ion-row>
          </div>

          <div class="commentSmall">
            <ion-row id="response">
              <button class="custom-button" (click)="showComment(c.id)" translate>news.comments.label.responseComment</button>
            </ion-row>
          </div>

          <ion-grid *ngIf="c.childComments.length > 0">
            <ion-row class="flex loh h-sb center" *ngFor="let child of c.childComments">
              <div class="comment-main response-comment">
                <ion-row class="comment-container">
                  <h1>
                    {{ child.employeeName }}
                  </h1>
                  <div class="column-flex">
                    <span>
                      {{ child.commentDate | date: 'dd/MM/yyyy' }}
                      <span translate>news.details.at </span>
                      {{ child.commentDate | date: 'HH:mm' }}
                    </span>
                    <span translate *ngIf="child.edited" class="edited"> news.comments.label.edited</span>
                  </div>
                  <ion-buttons class="lov center comment-button-area">
                    <ion-button (click)="showPopover(child.id, child, $event)" class="like-button">
                      <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
                    </ion-button>
                  </ion-buttons>
                </ion-row>
                <ion-row id="text">{{ child?.text }}</ion-row>
              </div>
            </ion-row>
          </ion-grid>

          <div class="input">
            <ion-row [hidden]="commentId === c.id ? false : true">
              <form #f="ngForm" (ngSubmit)="(f.valid)">
                <ion-textarea
                  id="responseComment"
                  rows="1"
                  class="newResponseComment"
                  name="comments"
                  placeholder="{{ 'news.list.comment' | translate }}"
                  [(ngModel)]="commentText"
                  required
                  onchange="this.value = this.value.trim()"></ion-textarea>
              </form>
              <button
                class="custom-button"
                *ngIf="btComment && !editedComment"
                [disabled]="!f.valid"
                end
                (click)="sendComment(false, c.id)">
                <ion-icon class="response-icon" name="paper-plane"></ion-icon>
              </button>
            </ion-row>
          </div>
        </ion-row>
      </ion-grid>

      <ion-fab
        [style.bottom.px]="topCalc(commentsDiv)"
        horizontal="end"
        vertical="bottom"
        slot="fixed"
        class="fab-icon"
        *ngIf="fab"
        (click)="scroll('targetTopComments')">
        <ion-fab-button class="fab-button">
          <ion-icon name="arrow-up-circle"></ion-icon>
        </ion-fab-button>
      </ion-fab>

      <div class="text-align-center" *ngIf="comments?.length > 0">
        <ion-button *ngIf="moreCommentsResults" fill="clear" (click)="getComments(true)" class="ion-no-padding moreComments" size="small">
          <ion-label color="primary text-align-center" translate>common.more</ion-label>
        </ion-button>

        <div *ngIf="!endCommentsResults">
          <ion-button fill="clear" class="ion-no-padding" *ngIf="!moreCommentsResults" expand="block">
            <ion-spinner name="crescent"></ion-spinner>
          </ion-button>
        </div>
      </div>
    </div>

    <div class="full-size card p0 marginTop visible-area">
      <ion-row class="ps">
        <form class="newComment" #f="ngForm" (ngSubmit)="(f.valid)">
          <ion-textarea
            #targetComment
            id="targetComment"
            [(ngModel)]="commentText"
            name="comments"
            placeholder="{{ 'news.label.newComment' | translate }}"
            required
            onchange="this.value = this.value.trim()"></ion-textarea>

          <ion-button *ngIf="btComment && !editedComment" [disabled]="!f.valid" end (click)="sendComment(true)">
            <span class="custom-button" ion-button icon-right translate> common.send </span>
          </ion-button>

          <ion-button *ngIf="btComment && editedComment" [disabled]="!f.valid" end (click)="editComment()">
            <button class="custom-button" ion-button icon-right translate>common.edit</button>
          </ion-button>

          <ion-button class="j-button" *ngIf="!btComment" expand="block">
            <ion-spinner name="crescent"></ion-spinner>
          </ion-button>
        </form>
      </ion-row>
    </div>
  </main>
</ion-content>
